import { useTranslation } from 'react-i18next'

import { categories, categoryLabels } from '../constants'
import SearchResultItem from '../SearchResultItem/SearchResultItem'
import CategorySection from './CategorySection'
import * as Styles from './styles'

const SearchResults = ({
  settings,
  shipments,
  returns,
  activeIndex,
  onSelect,
  onHover,
  hasQuery,
  hasResults,
  isLoading,
  quickLinks,
}) => {
  const { t } = useTranslation()

  if (!hasQuery) {
    return (
      <Styles.Container>
        <Styles.CategoryHeader>{t(categoryLabels[categories.pages])}</Styles.CategoryHeader>
        {quickLinks.map((link, index) => (
          <SearchResultItem
            key={link.path}
            result={{ id: link.path, title: t(link.translationKey), path: link.path, Icon: link.Icon }}
            active={index === activeIndex}
            onClick={() => onSelect({ path: link.path })}
            onMouseEnter={() => onHover(index)}
          />
        ))}
      </Styles.Container>
    )
  }

  if (!hasResults && !isLoading) {
    return (
      <Styles.Container>
        <Styles.EmptyState>{t('Sin resultados')}</Styles.EmptyState>
      </Styles.Container>
    )
  }

  let currentIndex = 0

  const settingsStartIndex = currentIndex
  currentIndex += settings.results.length

  const shipmentsStartIndex = currentIndex
  currentIndex += shipments.results.length

  const returnsStartIndex = currentIndex

  return (
    <Styles.Container data-testid="search-results">
      <CategorySection
        category={categories.settings}
        results={settings.results}
        loading={false}
        activeIndex={activeIndex}
        startIndex={settingsStartIndex}
        onSelect={onSelect}
        onHover={onHover}
      />
      <CategorySection
        category={categories.shipments}
        results={shipments.results}
        loading={shipments.loading}
        activeIndex={activeIndex}
        startIndex={shipmentsStartIndex}
        onSelect={onSelect}
        onHover={onHover}
      />
      <CategorySection
        category={categories.returns}
        results={returns.results}
        loading={returns.loading}
        activeIndex={activeIndex}
        startIndex={returnsStartIndex}
        onSelect={onSelect}
        onHover={onHover}
      />
    </Styles.Container>
  )
}

export default SearchResults
